import { MPCDeviceDetectionHelper } from "../helpers/deviceDetectionHelper";
import { MPCScrollLock } from "../helpers/scrollLock";
const SmartTimeout = require("smart-timeout");
const InfoIcon = require("../../images/info.svg") as string;

export module MPCToolTip {
    import DeviceDetectionHelper = MPCDeviceDetectionHelper.DeviceDetectionHelper;
    import ScrollLock = MPCScrollLock.ScrollLock;

    export class ToolTip {
        private tooltipContainer: HTMLElement;
        private mpcToolTip: HTMLElement;
        private toolTipHeight: number;
        private deviceDetectionHelper : DeviceDetectionHelper;
        private scrollLock: ScrollLock;
        private toolTipIsVisible: boolean;
        private tooltipId: string;
        private existingScrollEvent: EventListenerOrEventListenerObject;
        private mpcModalContainer: HTMLElement;

        public constructor(tooltipContainer: HTMLElement, mpcModalContainer: HTMLElement) {
            this.mpcModalContainer = mpcModalContainer;
            this.scrollLock = ScrollLock.instance;
            this.tooltipContainer = tooltipContainer;
            this.mpcToolTip = this.tooltipContainer.querySelector('.mpc-tooltip');
            this.tooltipContainer.querySelector('.mpc-info').innerHTML = InfoIcon;
            this.deviceDetectionHelper = DeviceDetectionHelper.instance;

            this.init();
        }

        private init(): void {
            this.toolTipIsVisible = false;
            this.setId();
            this.registerEvents();
        }

        private get supportsNativeSmoothScroll() {
            return 'scrollBehavior' in document.documentElement.style;
        }
        
        private registerEvents(): void {
            if(this.deviceDetectionHelper.isMobileShop()) {
                this.tooltipContainer.querySelector('.mpc-info').addEventListener('click', ()=> { this.openToolTipOverlay(); });
                this.mpcModalContainer.querySelector('.close-tooltip-btn').addEventListener('click', () => { this.closeToolTipOverlay(); });
                this.mpcModalContainer.querySelector('.close-tootlip-overlay').addEventListener('click', () => { this.closeToolTipOverlay(); });
            }
            else {
                this.existingScrollEvent = () => { this.hideToolTipOnScroll() };
                this.tooltipContainer.addEventListener('mouseover', (event: MouseEvent) => { this.handleMouseOverTooltipEvent(event); });

                this.tooltipContainer.addEventListener('mouseleave', (event: MouseEvent) => { this.handleMouseLeaveTooltipEvent(event); });
            }
        }

        private openToolTipOverlay(): void {
            let modalToolTipText: HTMLElement = this.mpcModalContainer.querySelector('.tooltip-text');
            const currentTooltipText: HTMLElement = this.mpcToolTip.querySelector('.tooltip-text');
            if (modalToolTipText && currentTooltipText) {
                modalToolTipText.innerHTML = currentTooltipText.innerHTML;
            }

            // Check rtf container:
            const richtextRoot: HTMLElement = this.mpcToolTip.querySelector('.richtext-root');
            if (richtextRoot && modalToolTipText) {
                modalToolTipText.innerHTML = richtextRoot.outerHTML;
            }

            let modalToolTipTitle: HTMLElement = this.mpcModalContainer.querySelector('.tooltip-title');
            const currentTooltipTitle: HTMLElement = this.mpcToolTip.querySelector('.tooltip-title');
            if (modalToolTipTitle && currentTooltipTitle) {
                modalToolTipTitle.innerHTML = currentTooltipTitle.innerHTML;
            }

            this.mpcModalContainer.classList.add('render-tooltip-overlay');

            const tooltTipeHeight: number = this.mpcModalContainer.querySelector('.tooltip-content').clientHeight;
            const calculatedWindowsSize: number = window.outerHeight - (window.outerHeight * 0.3);

            if (tooltTipeHeight <= calculatedWindowsSize) {
                this.mpcModalContainer.classList.add('no-touch-action');
                this.mpcModalContainer.ontouchmove = (event: TouchEvent) => { event.preventDefault(); }; // iOS ScrollLock
            }

            this.scrollLock.lock();
        }

        private closeToolTipOverlay(): void {
            this.mpcModalContainer.classList.remove('render-tooltip-overlay');
            this.mpcModalContainer.classList.remove('no-touch-action');
            this.mpcModalContainer.ontouchmove = () => {};
            this.scrollLock.unlock();
        }

        private handleMouseOverTooltipEvent(event: MouseEvent): void {
            if (!this.toolTipIsVisible) {
                this.mpcToolTip.classList.add('show-mpc-tooltip');
                const halfToolTipHeight: number = this.mpcToolTip.clientHeight / 2;
                const currentToolTipBottom: number = halfToolTipHeight + event.clientY;
                this.toolTipHeight = this.mpcToolTip.clientHeight;

                this.triggerAppShellPublish();
                this.toolTipIsVisible = true;

                if (window.innerHeight < currentToolTipBottom) {
                    this.centerTooltip(currentToolTipBottom - window.innerHeight + 20);
                } else if (halfToolTipHeight > event.clientY) {
                    this.centerTooltip(event.clientY - halfToolTipHeight - 20);
                }

                // attach to wheel event:
                document.addEventListener('wheel', this.existingScrollEvent);
            }
        }

        private centerTooltip(topPosition: number): void {
            if (this.supportsNativeSmoothScroll) {
                window.scrollBy({
                    "behavior": "smooth",
                    "top": topPosition
                });
            }
            else {
                // only for IE11
                let scrollTo: number = topPosition;

                if(scrollTo > 0) {
                    for (let index = 1; index <= scrollTo; index++) {
                        this.smoothScrollTo(1);
                    }
                }
                else {
                    for (let index = 1; index >= scrollTo; scrollTo++) {
                        this.smoothScrollTo(-1);
                    }
                }
            }
        }

        private handleMouseLeaveTooltipEvent(event: MouseEvent): void {
            const currentToolTipHeight: number = this.toolTipHeight + event.clientY;

            if (window.innerHeight < currentToolTipHeight || event.clientY < 224 && this.toolTipHeight > event.clientY) {
                if (!this.deviceDetectionHelper.isMobileShop() && window.shell)
                    window.shell.subscribeTo('mpc.close-visible-tooltip', (tooltipId: string) => { this.forceToCloseCurrentTooltip(tooltipId); }, undefined);

                this.hideTooltipAfter2Seconds();
            }
            else {
                this.mpcToolTip.classList.remove('show-mpc-tooltip');
                this.toolTipIsVisible = false;
                this.hideToolTipOnScroll();
            }
        }

        private hideToolTipOnScroll(): void {
            if (this.toolTipIsVisible) {
                this.mpcToolTip.classList.remove('show-mpc-tooltip');
                this.toolTipIsVisible = false;
            }

            // remove attached scroll event:
            document.removeEventListener('wheel', this.existingScrollEvent);
        }
        private hideTooltipAfter2Seconds(): void {
            SmartTimeout.set(() => {
                this.mpcToolTip.classList.remove('show-mpc-tooltip');
                if (!this.deviceDetectionHelper.isMobileShop() && window.shell)
                    window.shell.unsubscribeFrom('mpc.close-visible-tooltip', (tooltipId: string) => { this.forceToCloseCurrentTooltip(tooltipId); });
                this.toolTipIsVisible = false;
            }, 2000);
        }
        
        private smoothScrollTo(index: number): void {            
            // for the IE11 we still need old setTimeout
            setTimeout(() => { window.scrollBy(0, index) }, 50);
        }

        private triggerAppShellPublish(): void {
            // close any other tooltip if it is open:
            if (window.shell)                
                window.shell.publishTo('mpc.close-visible-tooltip', this.tooltipId);
        }

        private forceToCloseCurrentTooltip(tooltipId: string): void {
            if (this.toolTipIsVisible && this.tooltipId != tooltipId) {
                SmartTimeout.clear(this.handleMouseLeaveTooltipEvent);
                this.mpcToolTip.classList.remove('show-mpc-tooltip');
                this.toolTipIsVisible = false;
            }
        }

        private setId(): void {
            this.tooltipId = Math.random().toString(36).substring(2) + (new Date()).getTime().toString(36);
        }
    }
}

